import { DrawerHeader } from '@chakra-ui/react';

export const UiDrawerHeader = DrawerHeader;
